import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.flexara.ro';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Adaugă JWT token automat la fiecare cerere
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Dacă token expirat, delogheaza automat
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const register = (email: string, password: string, acceptedTc: boolean = false, acceptedPrivacy: boolean = false, acceptedHealth: boolean = false, acceptedMarketing: boolean = false) =>
  api.post('/auth/register', { email, password, accepted_tc: acceptedTc, accepted_privacy: acceptedPrivacy, accepted_health: acceptedHealth, accepted_marketing: acceptedMarketing });

export const updateMarketingConsent = (accepted: boolean) =>
  api.post('/profil/marketing-consent', { accepted_marketing: accepted });

export const login = (email: string, password: string) =>
  api.post('/auth/login', { email, password });

// Chat
export const sendMessage = (mesaj: string, conversatie_id?: string) =>
  api.post('/chat/send', { mesaj, conversatie_id });

export const getIstoricChat = () =>
  api.get('/chat/istoric');

// Tracker
export const addTracker = (nivel_durere: number, zona: string, observatii?: string, exercitii_facute?: boolean) =>
  api.post('/tracker/add', { nivel_durere, zona, observatii, exercitii_facute });

export const getIstoricTracker = (filtru: string = 'Tot') =>
  api.get(`/tracker/istoric?filtru=${filtru}`);

export const getStreak = () =>
  api.get('/tracker/streak');

export const getInsights = () =>
  api.get('/tracker/insights');

// Plan
export const genereazaPlan = (data: any) =>
  api.post('/plan/genereaza', data);

export const getPlanuri = () =>
  api.get('/plan/lista');

export const salveazaReminder = (reminder_activ: boolean, reminder_ora: number) =>
  api.post('/profil/reminder', { reminder_activ, reminder_ora });

export const retrageConsimtamant = () =>
  api.post('/gdpr/retrage-consimtamant');

export const trimiteCerereGDPR = (tip_cerere: string, descriere?: string) =>
  api.post('/gdpr/cerere', { tip_cerere, descriere });

export const getCereriGDPR = () =>
  api.get('/gdpr/cereri');

export const getCereriGDPRAdmin = () =>
  api.get('/admin/cereri-gdpr');

export const rezolvaCerereGDPR = (id: string) =>
  api.post(`/admin/cereri-gdpr/${id}/rezolva`);

export const reactivareConsimtamant = () =>
  api.post('/gdpr/reactivare-consimtamant');

export default api;
export const incarcaConversatieById = (conversatie_id: string) =>
  api.get(`/chat/conversatie/${conversatie_id}`);
